import styled from 'styled-components'
import { Button } from '@yes.technology/react-toolkit'

export const Container = styled.div`
  margin: auto 16px;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Content = styled.div`
  max-width: 632px;
  margin-inline: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;

  @media (max-width: 768px) {
    align-items: center;
  }
`

export const StyledButton = styled(Button)`
  max-width: 408px;
  margin: 0 auto;
`

export const Image = styled.img`
  @media (max-width: 768px) {
    width: 226px;
  }
`
